


































































































































import { Inject } from '@cds/common';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import FeedbackReplyPopup from './FeedbackReplyPopup.vue';

@Component({
  components: {
    FeedbackReplyPopup,
  }
})
export default class FeedbackList extends Vue {
  public queryForm: Record<string, any> = {
    current: 1,
    size: 10,
    total: 0,
    feedbackDateRange: [],
    replyDateRange: [],
    status: '',
  }
  
  public isShowPopup: Boolean = false;
  public currentFeedback: any = null;
  public isEditMode: Boolean = false;
  public tableData: any[] = [];
  public loading: Boolean = true;

  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  public get dialogTitle(): string {
    return this.isEditMode ? '编辑反馈回复' : '回复反馈';
  }

  public async created(): Promise<void> {
    await this.getList();
  }

  // 搜索
  public search() {
    this.queryForm.current = 1;
    this.getList();
  }

  // 重置
  public reset() {
    this.queryForm = {
      current: 1,
      size: 10,
      total: 0,
      feedbackDateRange: [],
      replyDateRange: [],
      status: '',
    };
    this.getList();
  }

  // 分页相关
  public handleSizeChange(size: number) {
    this.queryForm.size = size;
    this.getList();
  }

  public handleCurrentChange(current: number) {
    this.queryForm.current = current;
    this.getList();
  }

  // 获取反馈列表
  public async getList() {
    this.loading = true;
    let params: any = {
      current: this.queryForm.current,
      size: this.queryForm.size,
      status: this.queryForm.status || undefined,
      createDateStart: (this.queryForm.feedbackDateRange || [])[0],
      createDateEnd: (this.queryForm.feedbackDateRange || [])[1],
      replyDateStart: (this.queryForm.replyDateRange || [])[0],
      replyDateEnd: (this.queryForm.replyDateRange || [])[1],
    };

    try {
      const res = await this.nuoxiaoerService.fetchFeedbackList(params);
      console.log('反馈列表数据:', res);
      this.loading = false;

      const list = (res.records || []).map((x: any) => {
        return {
          ...x,
          createdTime: x.createdTime ? moment(x.createdTime).format('YYYY-MM-DD HH:mm:ss') : '--',
          replyTime: x.replyCreatedTime && x.status === 2 ? moment(x.replyCreatedTime).format('YYYY-MM-DD HH:mm:ss') : '--',
          statusName: x.status === 1 ? '未回复' : x.status === 2 ? '已回复' : '--', // 根据status设置statusName
        }
      });
      this.tableData = list;

      this.queryForm.total = res.total || 0;
      this.queryForm.current = res.current || 1;
    } catch (error) {
      this.loading = false;
      console.error('获取反馈列表失败：', error);
      this.$message.error('获取列表数据失败，请稍后重试');
    }
  }

  // 处理回复或编辑操作
  public async handleReplyOrEdit(row: any) {
    try {
      // 获取反馈详情
      const detail = await this.nuoxiaoerService.fetchFeedbackDetail({ id: row.uuid });
      console.log('反馈详情:', detail);
      
      this.currentFeedback = {
        ...row,
        ...detail,
        feedbackId: row.uuid
      };
      this.isEditMode = row.status === 2; // status为2表示已回复，进入编辑模式
      this.isShowPopup = true;
    } catch (error) {
      console.error('获取反馈详情失败：', error);
      this.$message.error('获取反馈详情失败，请稍后重试');
    }
  }

  // 保存后回调
  public handleAfterSaved() {
    console.log('反馈回复保存成功');
    this.getList();
    this.isShowPopup = false;
    this.currentFeedback = null;
  }

  // 取消弹窗
  public handleCancelPopup() {
    console.log('取消反馈弹窗');
    this.isShowPopup = false;
    this.currentFeedback = null;
  }

  // 关闭弹窗后
  public handleAfterClosePopup() {
    console.log('关闭反馈弹窗');
    this.currentFeedback = null;
  }
}
